import { Bee32 } from '@carbon/icons-react';
import React from 'react';
export default {
  Bee32,
  React
};